var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('CommonPageConfig'),_vm._v(" "),_c('AuthSignOn',{attrs:{"page":"sign-in","pre-email":_vm.email,"social-auth-code":_vm.socialAuthCode,"social-auth-error":_vm.socialAuthError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }